<template>
    <div class="address-item">
        <span class="address-icon__type" :class="'address-icon__type-' + type"></span>
        <div class="address-tips" @click="changeInformation">
            <div class="text-main" v-if="sendList.length==0">{{shou}}件人信息</div>
            <div class="text-main" v-if="sendList">{{sendList.name}} &nbsp;&nbsp;&nbsp;{{sendList.concatPhone}}</div>
            <div class="text-info" v-if="sendList.length==0">点击填写{{shou}}件人相关信息</div>
            <div class="text-info" v-if="sendList.provinceName">
                {{sendList.provinceName+sendList.cityName+sendList.districtName+sendList.clothingCityName+sendList.address}}
            </div>
        </div>
        <span v-if="!sendList.con" class="address-icon__contact"
              :class="[(sendList.con==true? 'con':'address-icon__contact-' + type)]" @click="handleClick">
                    <span class="directory_inquiries" :class="'directory_inquiries_'+type">地址簿</span>

        </span>
        <span v-else class="address-icon__contact"
              :class="[(sendList.con==true? 'con':'address-icon__contact-' + type)]" @click="handleClick"></span>
    </div>
</template>

<script>
    export default {
        name: "SenderItem",
        props: {
            type: {
                type: String,
                default: 'send'
            },
            shou: {
                type: String,
            },
            sendList: {},
            index: {}
        },

        methods: {
            handleClick() {
                if (this.sendList.con == true) {
                    this.$emit('removingSubscribers', this.index)
                } else {
                    this.$emit('click')
                }
            },
            changeInformation() {
                if (this.type === "send") {
                    if (this.sendList.length === 0) {
                        this.$router.push("/sendAddress/add");
                        return
                    }
                    this.$router.push("/sendAddress/modify/" + this.sendList.id)
                } else {
                    if (this.sendList.length === 0) {
                        this.$router.push("/acceptAddress/add");
                        return;
                    }
                    this.$router.push("/acceptAddress/modify/" + this.sendList.id)
                }
            },
        },
    }
</script>


<style scoped lang="scss">
    .text-main {
        font-size: 0.43rem;
        color: #2E2E2E;
    }

    .text-info {
        font-size: 0.32rem;
        color: #A6A6A6;
        width: 5.54rem
    }

    .address-item {
        background: #ffffff;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0.33rem 0;
        height: 1rem;
        border-bottom: 1px solid #e5e5e5;

        .directory_inquiries {
            position: relative;
            top: 0.63rem;
            display: inline-block;
            width: 1.07rem;
            font-size: 0.32rem;
            left: -0.21rem;
            color: blue;
        }

        .directory_inquiries_send {
            color: #234781;
        }

        .directory_inquiries_accept {
            color: #fea044;
        }
    }

    .address-icon__type {
        width: 0.73rem;
        height: 0.73rem;
        background: url('../../../assets/send.png') center / 100% no-repeat;
        margin: 0 0.16rem 0 0.32rem;

        &-accept {
            background: url('../../../assets/accept.png') center / 100% no-repeat;
        }
    }

    .address-tips {
        flex: 1;
        border-right: 1px solid #e5e5e5;
    }

    .address-icon__contact {
        width: 0.53rem;
        height: 0.53rem;
        background: url('../../../assets/contact-send.png') center / 100% no-repeat;
        margin: 0 0.49rem;
        position: relative;
        top: -0.23rem;

        &-accept {
            background: url('../../../assets/contact-accept.png') center / 100% no-repeat;
        }
    }

    .con {
        background: url('../../../assets/del.png') center / 100% no-repeat;
    }


</style>
